const GetCartItems = (data) => ({ type: 'GET', data });
const SetTotalItems = (totalItems) => ({ type: 'SET_TOTAL_ITEMS', data: totalItems });

const SetOpenCart = (isOpened) => ({ type: 'SET_OPEN_CART', data: isOpened });

export { GetCartItems, SetTotalItems, SetOpenCart };
